import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useModal } from '../../providers/ModalProvider';
import { formatPriceForView, formatQuantityForView } from '../../utils/format';
import { useLoader } from '../../utils/hooks';
import User from '../../utils/user';
import SecondaryButton from '../Buttons/SecondaryButton/SecondaryButton';

const SampleOrderDetail = (lodemore) => {
  const { t } = useTranslation();
  const params = useParams();
  const dataUser = useSelector((state) => state?.auth?.userDataDetail);

  const [orderTracking, setOrderTracking] = useState([]);
  const [orderDetail, serOrderDetail] = useState(null);
  const [sampleData, setSampleData] = useState({});
  const [product, setProducts] = useState([]);
  const [DocuRefLine, setDocuRefLine] = useState('');
  const loader = useLoader({ height: 546 });
  const { i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const getuserDataOrderDetails = () => {
    loader.watchPromise(
      axios
        .post(
          '/v1/get-sample-order-detail',
          {
            customerid: dataUser.ACCOUNTNUM,
            orderid: params.id,
          },
          {
            headers: {
              Authorization: `Bearer ${dataUser?.token}`,
            },
          }
        )
        .then((res) => {
          // Verifica se la risposta contiene un errore
          if (res?.data?.status === 'ERROR' || res?.data?.result?.status === 'ERROR') {
            console.error('API Error:', res?.data?.message || res?.data?.result?.message);
            serOrderDetail(null);
            return;
          }

          // Nuova struttura dati API
          const sampleOrderData = res?.data?.result?.data;
          
          // Se data è null, prova con l'API alternativa
          if (!sampleOrderData || sampleOrderData === null) {
            
            return axios.post(
              'https://digitex.filmar.it/admin/api/v1/get-sample-order-detail-by-digitex',
              {
                customerid: dataUser.ACCOUNTNUM,
                orderid: params.id,
              },
              {
                headers: {
                  application: 'application/json',
                },
              }
            ).then((altRes) => {
              if (altRes?.data?.success === false) {
                console.error('Alternative API Error:', altRes?.data?.message);
                serOrderDetail(null);
                return;
              }

              const altData = altRes?.data?.data;
              if (altData) {
                // Trasforma i dati della seconda API nella stessa struttura della prima
                let cartItems = [];
                try {
                  const prodotti = JSON.parse(altData.prodotti || '[]');
                  cartItems = prodotti.map((prod) => {
                    // Determina il codice sample in base al tipo
                    let codiceSample = '';
                    let configId = '';
                    
                    switch (prod.type) {
                      case 'book':
                        codiceSample = 'book';
                        configId = prod.itemId || prod.id;
                        break;
                      case 'colorCard':
                        codiceSample = 'color_card';
                        configId = prod.codice_famiglia || prod.id;
                        break;
                      case 'tello':
                        codiceSample = 'tello';
                        configId = prod.codice_famiglia || prod.itemid;
                        break;
                      case 'fondo cono':
                        codiceSample = 'fondo_cono';
                        configId = prod.itemid;
                        break;
                      default:
                        codiceSample = prod.type;
                        configId = prod.itemid || prod.codice_famiglia || prod.id;
                    }
                    
                    return {
                      config_id: configId,
                      quantity: prod.quantity,
                      product_type: prod.type,
                      color_id: null,
                      is_available_json: JSON.stringify({
                        ItemId: prod.itemId || prod.itemid,
                        sample: {
                          codice_sample: codiceSample,
                          name: prod.nome_famiglia || prod.name,
                          subProduct: {
                            codice_sub_sample: prod.itemId || prod.itemid,
                            description: prod.name,
                            nome_articolo: prod.name,
                          }
                        }
                      })
                    };
                  });
                } catch (e) {
                  console.error('Error parsing prodotti:', e);
                }

                // Parse RiepilogoCampionatura per ottenere l'indirizzo di spedizione
                let shippingAddress = altData.indirizzo_spedizione_completo;
                let totaleItems = cartItems.length;
                let totaleQuantita = cartItems.reduce((sum, item) => sum + (parseFloat(item.quantity) || 0), 0);
                
                try {
                  if (altData.RiepilogoCampionatura) {
                    const riepilogo = JSON.parse(altData.RiepilogoCampionatura);
                    
                    // Costruisci indirizzo completo da riepilogo
                    if (riepilogo.indirizzo_spedizione) {
                      const addr = riepilogo.indirizzo_spedizione;
                      shippingAddress = `${addr.addressName || ''} - ${addr.street || ''} ${addr.number || ''}, ${addr.city || ''} ${addr.province || ''} ${addr.zip || ''} (${addr.country || ''})`.trim();
                    }
                    
                    // Usa i totali dal riepilogo se disponibili
                    if (riepilogo.totale_items) totaleItems = riepilogo.totale_items;
                    if (riepilogo.totale_quantita) totaleQuantita = riepilogo.totale_quantita;
                  }
                } catch (e) {
                  console.error('Error parsing RiepilogoCampionatura:', e);
                }
                
                // Se non c'è indirizzo dal riepilogo, costruiscilo dai campi separati
                if (!shippingAddress || shippingAddress === '-') {
                  shippingAddress = `${altData.Azienda || ''} - ${altData.Indirizzo || ''} ${altData.NumeroCivico || ''}, ${altData.Citta || ''} ${altData.Provincia || ''} ${altData.CodicePostale || ''} (${altData.Nazione || ''})`.trim();
                }

                const transformedData = {
                  result: {
                    data: {
                      OrderIdAX: altData.OrderIdAX,
                      order_id: altData.OrderIdAX,
                      order_date: altData.DataOrdine,
                      business_name: altData.Azienda || [altData.NomeCampionatura, altData.CognomeCampionatura].filter(Boolean).join(' '),
                      vat_number: altData.PartitaIva_CF,
                      EmailCampionatura: altData.EmailCampionatura,
                      TelefonoCampionatura: altData.TelefonoCampionatura,
                      NoteOrdine: altData.NoteOrdine,
                      numero_prodotti: totaleItems,
                      quantita_articoli: totaleQuantita,
                      cart_items: cartItems,
                      shipping_address: {
                        ADDRESS: shippingAddress
                      }
                    }
                  }
                };

                setSampleData(transformedData);
                serOrderDetail(transformedData.result.data);
                setDocuRefLine(altData.NoteOrdine || '');
                setOrderTracking(altData.orderTracking || []);
              } else {
                serOrderDetail(null);
              }
            });
          }
          
          if (sampleOrderData) {
            setSampleData(res?.data); // Salva l'intera risposta con result.data
            serOrderDetail(sampleOrderData);
            setDocuRefLine(sampleOrderData.NoteOrdine || '');
            setOrderTracking(sampleOrderData.orderTracking || res?.data?.result?.data?.orderTracking || res?.data?.result?.data?.['orderTracking'] || []);
          } else {
            serOrderDetail(null);
          }
        })
        .catch((error) => {
          console.log('error', error);
          serOrderDetail(null);
        })
    );
  };

  const getproducts = async (array) => {
    // Non utilizzato per campionature con nuova struttura
  };

  const availabilitysum = (items, prop) => {
    return items.reduce(function (a, b) {
      return parseFloat(a) + parseFloat(b[prop]);
    }, 0);
  };

  const modal = useModal();

  useEffect(() => {
    document.getElementById('home_page_class').classList.remove('home_page');
    getuserDataOrderDetails();
  }, []);

  // Formatta la data
  const formatDate = (dateString) => {
    if (!dateString) return null;
    try {
      return new Date(dateString);
    } catch {
      return null;
    }
  };

  // Calcola i totali considerando che 0.3 di fondo_cono = 1 pezzo
  const calculateTotals = (cartItems) => {
    if (!cartItems?.length) return { totalItems: 0, totalQty: 0 };

    let totalItems = 0;
    let totalQty = 0;

    cartItems.forEach((item) => {
      let productDetails = null;
      try {
        productDetails = item.is_available_json ? JSON.parse(item.is_available_json) : null;
      } catch (e) {
        // Ignora errori di parsing
      }

      const codiceSample = productDetails?.sample?.codice_sample || item?.sample?.codice_sample;
      const quantity = parseFloat(item.quantity) || 0;

      // Per fondo_cono, 0.3 conta come 1 pezzo
      if (codiceSample === 'fondo_cono' && quantity === 0.3) {
        totalItems += 1;
        totalQty += 1;
      } else {
        totalItems += 1;
        totalQty += quantity;
      }
    });

    return { totalItems, totalQty };
  };

  return (
    <>
      <div className="main_content" style={{ paddingBottom: 100 }}>
        <section className="order_detailss">
          <div className="container">
            <div className="order_number_main">
              <div className="order_number_detail">
                <p>
                  {t('Campionatura')}
                  {sampleData?.result?.data?.order_id ? <span>#{sampleData.result.data.order_id}</span> : null}
                </p>
              </div>
              <div className="order_btn">
                <Link to="/dashboard-list?tab=Campionature">
                  <SecondaryButton>{t('Torna alla lista campionature')}</SecondaryButton>
                </Link>
              </div>
            </div>

            {loader.asJsx ||
              (orderDetail ? (
                <>
                  <div className="order_pickup_detail">
                    <div className="order_address">
                      <p>
                        {t('Data creazione')}:{' '}
                        <span>
                          {formatDate(sampleData?.result?.data?.order_date) ? (
                            <Moment date={formatDate(sampleData.result.data.order_date)} format="DD/MM/YYYY" />
                          ) : '-'}
                        </span>
                      </p>
                      <p>
                        {t('Utente')}: <span>{sampleData?.result?.data?.business_name || 'master'}</span>
                      </p>
                    </div>
                  </div>

                  {/* Sezione Articoli */}
                  <div className="item_availability_section">
                    <div className="item_availability_heading">
                      <h3>{t('Articoli')}</h3>
                    </div>
                    {sampleData?.result?.data?.cart_items?.map((item, i) => {
                      // Parse del JSON per ottenere i dettagli del prodotto
                      let productDetails = null;
                      try {
                        productDetails = item.is_available_json ? JSON.parse(item.is_available_json) : null;
                      } catch (e) {
                        console.error('Error parsing is_available_json:', e);
                      }

                      // Determina il codice sample da usare
                      const codiceSample = productDetails?.sample?.codice_sample || item?.sample?.codice_sample;
                      const subProduct = productDetails?.sample?.subProduct || item?.sample?.subProduct;

                      // Se è fondo_cono, usa nome_articolo, altrimenti usa description
                      let sampleName;
                      let showTechnicalDetails = false;
                      
                      if (codiceSample === 'fondo_cono') {
                        sampleName = subProduct?.nome_articolo;
                        showTechnicalDetails = true;
                      } else {
                        sampleName = subProduct?.description || productDetails?.sample?.name || item?.sample?.name;
                      }

                      // Determina l'immagine da mostrare in base al tipo di sample
                      let sampleImage = null;
                      if (codiceSample === 'tello') {
                        sampleImage = '/images/samples/TELO.jpg';
                      } else if (codiceSample === 'fondo_cono') {
                        sampleImage = '/images/samples/FONDO_CONO.jpg';
                      } else if (codiceSample === 'cartella' && item.config_id) {
                        sampleImage = `/images/samples/families/${item.config_id}.png`;
                      }

                      return (
                        <div className="order_available_item" key={i}>
                          <div className="item_availability_detail">
                            <div className="available_img">
                              {sampleImage ? (
                                <img
                                  className="colorSchema"
                                  style={{ objectFit: 'contain' }}
                                  src={sampleImage}
                                  alt={codiceSample}
                                />
                              ) : item?.image ? (
                                <img className="colorSchema" src={item.image} alt="book" />
                              ) : item?.color?.hex_image ? (
                                <img className="colorSchema" src={item.color.hex_image_url} alt="color" />
                              ) : (
                                <div
                                  className="colorSchema"
                                  style={{
                                    backgroundColor: `${item?.color?.hex || '#cccccc'}`,
                                  }}
                                ></div>
                              )}
                            </div>
                            <div className="availab_item">
                              <div className="availab_item_name">
                                <p className="article_name">
                                  <strong>{item.config_id || '-'}</strong>
                                </p>
                                {sampleName && (
                                  <p>
                                    <span className="order_name">{sampleName}</span>
                                    {showTechnicalDetails && subProduct?.nm && (
                                      <span className="order_num">
                                        {' '}
                                        | Nm {subProduct.nm} | Ne {subProduct.ne} | Finezza {subProduct.finezza}
                                      </span>
                                    )}
                                  </p>
                                )}
                              </div>
                              <div className="availab_item_detail availab_item_quantity">
                                <p>
                                  <strong>{t('Quantità')}:</strong> {item.quantity || '-'}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Riepilogo */}
                  <div className="order_total_section">
                    <div className="order_total">
                      <div className="order_total_item">
                        <p>{t('common.total_items')}</p>
                        <p>{calculateTotals(sampleData?.result?.data?.cart_items).totalItems}</p>
                      </div>
                      <div className="order_total_item">
                        <p>{t('common.total_qty')}</p>
                        <p>{calculateTotals(sampleData?.result?.data?.cart_items).totalQty}</p>
                      </div>
                    </div>
                  </div>

                  {/* Dati di spedizione */}
                  <div className="shipping_data">
                    <div className="item_availability_heading">
                      <h3>{t('Dati di spedizione')}</h3>
                    </div>
                    <div className="shipping_item_detail">
                      <div className="business_detail">
                        <div className="business_detail_flex">
                          <p>
                            {t('Ragione sociale')} <strong>{sampleData?.result?.data?.business_name || dataUser?.business_name}</strong>
                          </p>
                        </div>
                        <div className="business_detail_flex">
                          <p>
                            {t('P.IVA')} <strong>{sampleData?.result?.data?.vat_number || dataUser?.vat_number}</strong>
                          </p>
                        </div>
                        <div className="business_detail_flex">
                          <p>
                            {t('Email')} <strong>{sampleData?.result?.data?.EmailCampionatura || dataUser?.email}</strong>
                          </p>
                        </div>
                        <div className="business_detail_flex">
                          <p>
                            {t('Telefono')} <strong>{sampleData?.result?.data?.TelefonoCampionatura || dataUser?.mobile_no}</strong>
                          </p>
                        </div>
                      </div>
                      <div className="business_detail_flex">
                        <p>
                          {t('Indirizzo')} <strong>
                            {sampleData?.result?.data?.shipping_address?.ADDRESS || '-'}
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Note ordine */}
                  {DocuRefLine ? (
                    <div className="shipping_data payment_method order_note">
                      <div className="item_availability_heading">
                        <h3>{t('Nota d\'ordine')}</h3>
                      </div>
                      <div className="shipping_item_detail ">
                        <div className="business_detail_flex">
                          <p>{DocuRefLine}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </>
              ) : (
                <div className="order_error_message">{t('order_could_not_be_loaded')}</div>
              ))}

            {orderTracking.length > 0 ? (
              <div className="shipping_data payment_method">
                <div className="item_availability_heading">
                  <h3>{t('Tracciamento')}</h3>
                </div>
                <div className="shipping_item_detail">
                  <div className="business_detail_flex">
                    {orderTracking.map((o, idx) => (
                      <div className="tracking" key={idx}>
                        <p>
                          {t('Nome del corriere')}: <strong>{o.carrier_name}</strong>
                        </p>
                        <p>
                          {t('Numero di tracciamento')}: <strong>{o.tracking_number}</strong>
                        </p>
                        <p className="data">
                          {t('date')}: <strong>{o.date ? <Moment format="D MMM YYYY">{o.date}</Moment> : '-'}</strong>
                        </p>
                        {o.url ? (
                          <p className="flex">
                            <strong>
                              <a className="black" href={o.url}>
                                {t('tracking_link')}
                              </a>
                            </strong>
                          </p>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </section>
      </div>
    </>
  );
};
export default SampleOrderDetail;
